import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Stack } from "@mui/material";
import { ReactNode } from "react";
import { useTranslator } from "../i18n/translator.ts";

interface CardsTableToolbarProps {
  filterControls?: ReactNode;
  onReload: () => void;
  isReloading: boolean;
  resultInfo?: ReactNode;
  pageActions?: ReactNode;
}

/**
 * The row between a card table page's title and its table, so every page
 * places its refresh button in the same spot.
 */
export const CardsTableToolbar = ({
  filterControls,
  onReload,
  isReloading,
  resultInfo,
  pageActions,
}: CardsTableToolbarProps) => {
  const translator = useTranslator();

  return (
    <Stack
      direction="row"
      width="100%"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {filterControls}
        <Button
          onClick={onReload}
          size="small"
          variant="contained"
          disabled={isReloading}
          loading={isReloading}
          sx={{ height: "100%" }}
          aria-label={translator("refresh")}
        >
          <RefreshIcon />
        </Button>
        {resultInfo}
      </Stack>
      {pageActions && (
        <Stack direction="row" alignItems="center" gap={1}>
          {pageActions}
        </Stack>
      )}
    </Stack>
  );
};
